import {
  HOOPLA_TYPE,
  HOOPLA_ITEM_STATUS,
} from './../../../../services/thirdparty/hoopla/hoopla.service';
import { RoutingService } from './../../../../services/routing/routing.service';
import {
  Component,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SharedService } from '../../../../services/shared/shared.service';
import {
  EContentService,
  ResponseMessages,
} from '../../../../services/thirdparty/econtent.service';
import { IHooplaItem } from '../../../../services/thirdparty/hoopla/hoopla.service';

@Component({
  selector: 'ag-hoopla-fullrecord',
  templateUrl: './hoopla-fullrecord.component.html',
  styleUrls: ['./hoopla-fullrecord.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HooplaFullRecordComponent implements OnChanges {
  @Input() item: IHooplaItem;
  @Input() format: string;
  @Input() isGuest: boolean;
  @Input() purchaseModel: HOOPLA_TYPE;
  @Output() refreshItem = new EventEmitter<null>();
  showCheckOut: boolean;
  showCancelHold: boolean;
  showPlaceHold: boolean;
  disableCheckout: boolean;

  constructor(
    private _eContentService: EContentService,
    private _sharedService: SharedService,
    private _routingService: RoutingService,
  ) {}

  ngOnChanges({ item }: SimpleChanges): void {
    if (item?.currentValue) {
      this.item = item.currentValue;
      this.disableCheckout =
        this.item.availability === 'Limit Reached' ||
        this.item.status == HOOPLA_ITEM_STATUS.UNAVAILABLE;
    }
    if (this.item && this.purchaseModel) {
      this.showCheckOut =
        this.purchaseModel === HOOPLA_TYPE.INSTANT ||
        (this.purchaseModel === HOOPLA_TYPE.FLEX &&
          ((this.item.isReserved && this.item.isReadyForPickup) ||
            this.item.status == HOOPLA_ITEM_STATUS.BORROW));

      this.showCancelHold =
        this.purchaseModel === HOOPLA_TYPE.FLEX &&
        !this.item.isCheckedOut &&
        this.item.isReserved &&
        !this.item.isReadyForPickup;

      this.showPlaceHold =
        this.purchaseModel === HOOPLA_TYPE.FLEX &&
        !this.showCancelHold &&
        !this.item.isCheckedOut &&
        !this.item.isReserved &&
        this.item.status === HOOPLA_ITEM_STATUS.HOLD;
    }
  }

  goToHooplaFulfillment(): void {
    window.open(this.item.downloadLink, '_blank');
  }

  goToHoopla(): void {
    window.open('http://www.hoopladigital.com/', '_blank');
  }

  placeHold(): void {
    this._eContentService.hooplaPlaceHold(this.item.id).subscribe(
      () => {
        this._sharedService.openSnackBar(ResponseMessages.PLACE_HOLD_SUCCESS);
        this.refresh();
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.PLACE_HOLD_ERROR);
      },
    );
  }

  cancelHold(): void {
    this._eContentService.hooplaCancelHold(this.item.id).subscribe(
      () => {
        this._sharedService.openSnackBar(ResponseMessages.CANCEL_SUCCESS);
        this.refresh();
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.CANCEL_ERROR);
      },
    );
  }

  checkout(): void {
    this._eContentService.hooplaCheckout(this.item.id).subscribe(
      (response) => {
        this.refresh();
        window.open(response.downloadLink, '_blank');
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.CHECKOUT_ERROR, 'ok');
      },
    );
  }

  earlyReturn(): void {
    this._eContentService.hooplaReturnTitle(this.item.id).subscribe(
      () => {
        this._sharedService.openSnackBar(ResponseMessages.EARLY_RETURN_SUCCESS, 'ok');
        this.refresh();
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.EARLY_RETURN_ERROR, 'ok');
      },
    );
  }

  refresh(): void {
    this.refreshItem.emit();
  }

  login(): void {
    this._routingService.goToLogin();
  }
}
